export class customEventsNames {
    constructor() {
        this.openModal = 'openModal';
        this.closeModal = 'closeModal';
        this.playVideoInModal = 'playVideoInModal';
        this.playYoutubeVideoInModal = 'playYoutubeVideoInModal';
        this.videoPlayingInModal = 'videoStartedPlayingInModal';

        this.accordionInitialised = 'accordionInitialized';
        this.accordionActivateItemEventName = 'activateAccordionItem';
        this.accordionDeactivateItemEventName = 'deactivateAccordionItem';
        this.accordionDeactivateAllItemsEventName = 'deactivateAllAccordionItems';
    }
};
export default new customEventsNames();